/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Coming_Soon_HintInputs */

const cs_portals_coming_soon_hint = /** @type {(inputs: Portals_Coming_Soon_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export na tento portál připravujeme — zapnutí si zapamatujeme, ale inzerát zatím neodešleme.`)
};

const en_portals_coming_soon_hint = /** @type {(inputs: Portals_Coming_Soon_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push to this portal is not live yet — enabling remembers your choice but will not publish the listing.`)
};

/**
* | output |
* | --- |
* | "Push to this portal is not live yet — enabling remembers your choice but will not publish the listing." |
*
* @param {Portals_Coming_Soon_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_coming_soon_hint = /** @type {((inputs?: Portals_Coming_Soon_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Coming_Soon_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_coming_soon_hint(inputs)
	return cs_portals_coming_soon_hint(inputs)
});